import {
  BotaoCancelarRecorrencia,
  BotaoDesistir,
  BotaoFazerPagamento,
  BoxCountModal,
  CabecalhoModalCancelarRecorrencia,
  ContainerAccordions1,
  ContainerAccordionsDireita,
  ContainerAccordionsEsquerda,
  ContainerInputBoxCountModal,
  ContainerRemover,
  ContainerTextoValorTotalPlano,
  ContainerTituloValorTotalPlano,
  ContainerValorTotalPlano,
  FooterModal,
  LinhaCabecalhoModalCancelarRecorrencia,
  LinhaClaraExtras,
  LinhaEscuraExtras,
  NumberInputCustomizadoModal,
  SubtituloValorPlano,
  TextoAdicionar,
  TextoBotaoCancelarRecorrencia,
  TextoBotaoDesistir,
  TextoBotaoFazerPagamento,
  TextoBoxCountModal,
  TextoCabecalhoModalCancelarRecorrencia,
  TextoCancelarRecorrencia,
  TextoReativarRecorrencia,
  TextoRemover,
  TextoSubtituloModal,
  TituloLinhaExtras,
  TituloValorTotalPlano,
  ValorTotalPlano,
} from "./styles";

import { PopupCustomizadoMin } from "../../../../components/Contrato/Ativo/styles";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import {
  StyledAccordion,
  TextoLinha,
  TypographyTitulo,
} from "../../../contratoCustomizado/cadastro/styles";
import { AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IconeBotao } from "../../../selecaoEmpresas/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ContainerPopup } from "../../../../components/Contrato/Padrao/styles";
import { useEffect, useState } from "react";
import { agruparItensPorModulo, gerarItemExpansao } from "./componentes/ModularizadorItens";
import { ResponseExtrasWaychef } from "../../../../services/contrato/waychef/MapperExtrasWaychef";
import { useTheme } from "@emotion/react";
import useTamanhoTela from "../../../../utils/useTamanhoTela";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../../../contexts/api";
import formatarReal from "../../../../utils/formatarReal";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import ModalDetalharPlano from "../../comparacaoPlanos";
import {
  BotaoAzulVazado,
  BotaoVerdePreenchido,
  BotaoVermelhoPreenchido,
  BotaoVermelhoSemFundo,
  BotaoVermelhoVazado,
} from "../../../../components/Botao";
import { ItensRealizarPagamentoFactory } from "../../../realizarPagamento/itensRealizarPagamentoFactory";
import { ResponseCalculoExtras } from "../../../../services/contrato/calculo/MapperCalculoExtras";
import { getUrlEmpresa } from "../../../../enums/TipoEmpresa";
import {
  CampoDeInputNumericoComSetas,
  CampoDeInputNumericoComSetasZero,
} from "../../../../components/CampoInput";
import GerarModalResponsivo from "../../../../components/GerarModalResponsivo";
import Carregando from "../../../carregando";
import { useAuth } from "../../../../contexts/auth";
import { AlterarQuantidadeComSetas } from "./ItensWaybe";
import { ModalAdicionarQuantidade } from "./componentes/ModalAdicionarQuantidade";

export function ItensWaychef({ aplicacao, irParaPagamento, irParaPlano }) {
  const { t } = useTranslation("common");
  const { t: tPagamento } = useTranslation("pagamento");
  const ITEM_NAO_CONTRATADO = "ITEM_NAO_CONTRATADO";
  const ITEM_CONTRATADO = "ITEM_CONTRATADO";
  const ITEM_RECORRENCIA_CANCELADA = "ITEM_RECORRENCIA_CANCELADA";
  const SESSAO_EXTRA = "SESSAO_EXTRA";
  const SITEF_PDV = "SITEF_PDV";

  const { largura } = useTamanhoTela();
  const tema = useTheme();
  const navigate = useNavigate();
  const { get, put, del } = useApi();

  const [listaExtras, setListaExtras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [desabilitado, setDesabilitado] = useState(false);

  useEffect(() => {
    buscarExtras();
  }, []);

  function mapExtrasComCamposTela(extra) {
    let status;
    if (extra.tipoStatusContrato === "RECORRENCIA_CANCELADA") {
      status = ITEM_RECORRENCIA_CANCELADA;
    } else if (extra.tipoStatusContrato === "ATIVO") {
      status = ITEM_CONTRATADO;
    } else {
      status = ITEM_NAO_CONTRATADO;
    }

    return {
      ...extra,
      camposTela: {
        adicionadoAoCarrinho: 0,
        status: status,
      },
    };
  }

  function buscarExtras() {
    if (aplicacao.possuiExtras) {
      get("/contrato/consumidor/waychef/empresa-contrato/item/extra")
        .then((response) => {
          if (response.status !== 200) {
            setListaExtras([]);

            if (response.data?.message?.includes("Contratos gratuitos")) {
              toast.error(tPagamento("messages.extraNotAllowed"));
            } else {
              toast.error(
                response.data.message
                  ? response.data.message
                  : tPagamento("messages.extrasLoadError"),
              );
            }
            throw new Error();
          }

          let data = ResponseExtrasWaychef.map(response.data);
          data = data.map((e) => mapExtrasComCamposTela(e));
          setListaExtras(data);
        })
        .catch((error) => {
          setListaExtras([]);
          console.error(error);
        })
        .finally(() => setLoading(false));
    } else {
      setListaExtras(null);
      setLoading(false);
    }
  }

  function ItemExtra({ item, index }) {
    if (index % 2 === 0) {
      return <ItemExtraLinhaClara item={item} />;
    } else {
      return <ItemExtraLinhaEscura item={item} />;
    }
  }

  function ItemExtraLinhaClara({ item }) {
    return (
      <LinhaClaraExtras>
        <TituloLinhaExtras>{item.nomeExtra}</TituloLinhaExtras>
        <TextoLinha style={{ marginRight: largura < 768 ? 45 : 0 }}>
          {item.valorUnitario > 0 ? formatarReal(item.valorUnitario) : tPagamento("status.free")}
        </TextoLinha>

        {<BotaoAcaoExtra item={item} />}
      </LinhaClaraExtras>
    );
  }

  function ItemExtraLinhaEscura({ item }) {
    return (
      <LinhaEscuraExtras>
        <TituloLinhaExtras>{item.nomeExtra}</TituloLinhaExtras>
        <TextoLinha style={{ marginRight: largura < 768 ? 45 : 0 }}>
          {item.valorUnitario > 0 ? formatarReal(item.valorUnitario) : tPagamento("status.free")}
        </TextoLinha>
        {<BotaoAcaoExtra item={item} />}
      </LinhaEscuraExtras>
    );
  }

  function BotaoAcaoExtra({ item }) {
    if (
      !item.estaContratado &&
      item.camposTela.adicionadoAoCarrinho > 0 &&
      !(item.camposTela.tipoItemPlanoWaychef == SITEF_PDV)
    ) {
      return <BotaoRemoverExtra item={item} />;
    }

    switch (item.camposTela.status) {
      case ITEM_CONTRATADO:
        if (item.tipoItemPlanoWaychef == SESSAO_EXTRA) {
          return <PopupCancelarRecorrencia item={item} />;
        } else if (item.tipoItemPlanoWaychef == SITEF_PDV) {
          return <AlterarQuantidade item={item} />;
        } else {
          return <BotaoCancelarRecorrencia item={item} />;
        }
      case ITEM_NAO_CONTRATADO:
        if (item.tipoItemPlanoWaychef == SITEF_PDV) {
          return <AlterarQuantidade item={item} />;
        } else {
          return <BotaoAdicionarExtra item={item} />;
        }
      case ITEM_RECORRENCIA_CANCELADA:
        if (item.tipoItemPlanoWaychef == SITEF_PDV) {
          return <AlterarQuantidade item={item} />;
        } else {
          return <BotaoReativarRecorrenciaExtra item={item} />;
        }
    }
  }

  function BotaoAdicionarExtra({ item }) {
    return (
      <TextoAdicionar
        onClick={() => adicionarExtra(item.idItemConfiguracao)}
        style={{ width: 180 }}
      >
        {tPagamento("extras.add")}
      </TextoAdicionar>
    );
  }

  function adicionarExtra(idExtra, quantidade = null) {
    const novaListaExtras = listaExtras.map((e) => {
      if (idExtra === e.idItemConfiguracao) {
        if (quantidade) {
          e.camposTela.adicionadoAoCarrinho = quantidade;
        } else {
          e.camposTela.adicionadoAoCarrinho = 1;
        }
      }
      return e;
    });
    console.log(novaListaExtras);

    setListaExtras(novaListaExtras);
  }

  function BotaoRemoverExtra({ item }) {
    return (
      <ContainerRemover
        onClick={() => removerExtra(item.idItemConfiguracao)}
        style={{ width: 180 }}
      >
        <TextoRemover>{tPagamento("extras.remove")}</TextoRemover>
      </ContainerRemover>
    );
  }

  function removerExtra(idExtra) {
    const novaListaExtras = listaExtras.map((e) => {
      if (idExtra === e.idItemConfiguracao) {
        e.camposTela.adicionadoAoCarrinho = 0;
      }

      return e;
    });

    setListaExtras(novaListaExtras);
  }

  function zerarExtras() {
    const novaListaExtras = listaExtras.map((e) => {
      e.camposTela.adicionadoAoCarrinho = 0;

      return e;
    });

    setListaExtras(novaListaExtras);
  }

  function BotaoReativarRecorrenciaExtra({ item }) {
    return (
      <TextoReativarRecorrencia
        // style={{ display: largura > 768 ? "flex" : "none", width: 180 }}
        style={{ display: `flex`, width: 180 }}
      >
        {tPagamento("extras.recurrenceCancelled")}
      </TextoReativarRecorrencia>
    );
  }

  function PopupCancelarRecorrencia({ item }) {
    const [quantidadeCancelar, setQuantidadeCancelar] = useState(0);

    function contratar() {
      del(
        `/contrato/consumidor/waychef/empresa-contrato/item/extra/${item.idItemConfiguracao}/${quantidadeCancelar}`,
      )
        .then((response) => {
          if (response.status === 200) {
            toast.success(tPagamento("messages.recurrenceCancelled"));
            buscarExtras();
          } else {
            throw new Error(response);
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error(tPagamento("messages.cancelRecurrenceError"));
        });
    }

    return (
      <GerarModalResponsivo
        blocking
        larguraQuebra={768}
        trigger={
          <TextoCancelarRecorrencia
            style={{
              width: 180,
              cursor: "pointer",
            }}
          >
            {tPagamento("extras.cancelRecurrence")}
          </TextoCancelarRecorrencia>
        }
        modal
        nested
      >
        {(close) => (
          <ContainerPopup>
            <CabecalhoModalCancelarRecorrencia>
              <TextoCabecalhoModalCancelarRecorrencia>
                {tPagamento("extras.cancelExtraSessions")}
              </TextoCabecalhoModalCancelarRecorrencia>
            </CabecalhoModalCancelarRecorrencia>
            <ContainerInputBoxCountModal>
              <CampoDeInputNumericoComSetas
                variant="standard"
                label={tPagamento("extras.quantity")}
                value={parseInt(quantidadeCancelar)}
                style={{ width: "100%" }}
                onChange={setQuantidadeCancelar}
              />
            </ContainerInputBoxCountModal>
            <FooterModal>
              <BotaoVermelhoVazado onClick={close} texto={t("buttons.cancel")} />
              <BotaoVermelhoPreenchido texto={t("buttons.confirm")} onClick={contratar} />
            </FooterModal>
          </ContainerPopup>
        )}
      </GerarModalResponsivo>
    );
  }

  function BotaoCancelarRecorrencia({ item }) {
    function cancelar() {
      del(`/contrato/consumidor/waychef/empresa-contrato/item/extra/${item.idItemConfiguracao}/1`)
        .then((response) => {
          if (response.status === 200) {
            toast.success(tPagamento("messages.recurrenceCancelled"));
            buscarExtras();
          } else {
            throw new Error(response);
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error(tPagamento("messages.cancelRecurrenceError"));
          buscarExtras();
        });
    }

    return (
      <TextoCancelarRecorrencia
        onClick={cancelar}
        style={{
          width: 180,
          cursor: "pointer",
        }}
      >
        {tPagamento("extras.cancelRecurrence")}
      </TextoCancelarRecorrencia>
    );
  }

  function AlterarQuantidade({ item }) {
    console.log(item);

    const [quantidade, setQuantidade] = useState(null);

    useEffect(() => {
      setQuantidade(
        item?.quantidadeContratada -
          item?.quantidadeRecorrenciaCancelada +
          item?.camposTela?.adicionadoAoCarrinho,
      );
    }, []);

    return (
      <div
        style={
          largura > 768
            ? { width: "100%", maxWidth: "180px", position: "relative" }
            : {
                width: "100%",
                maxWidth: "180px",
                flexDirection: "column",
                position: "relative",
                display: "flex",
                gap: "10px",
              }
        }
      >
        <div
          style={
            largura > 1200
              ? largura > 1500
                ? { width: "180px", position: "absolute", left: "-13.5vw" }
                : { width: "180px", position: "absolute", left: "-10vw" }
              : { width: "180px", fontSize: 12 }
          }
        >
          {tPagamento("extras.quantity")} {quantidade}
        </div>
        <ModalAdicionarQuantidade
          item={item}
          adicionarExtra={adicionarExtra}
          buscarExtras={buscarExtras}
          tipoItem={`waychef`}
        />
      </div>
    );
  }

  function PainelAlteracaoExtras({ extrasDisponiveis }) {
    const { post } = useApi();

    const [possuiExtrasAdicionados, setPossuiExtrasAdicionados] = useState(0);
    const [calculoExtrasIncrementados, setCalculoExtrasIncrementados] = useState(null);

    useEffect(() => {
      verificarPossuiExtrasAdicionados();
      calcularTotalExtrasIncrementados();
    }, []);

    function calcularTotalExtrasIncrementados() {
      const listaExtrasAdicionados = [];
      for (const extra of extrasDisponiveis) {
        if (extra.camposTela.adicionadoAoCarrinho > 0) {
          listaExtrasAdicionados.push({
            idItemConfiguracao: extra.idItemConfiguracao,
            quantidadeExtra: extra.camposTela.adicionadoAoCarrinho,
          });
        }
      }

      if (listaExtrasAdicionados.length > 0) {
        post("/contrato/consumidor/waychef/empresa-contrato/item/extra/calculo", {
          listaExtras: listaExtrasAdicionados,
        })
          .then((response) => {
            if (response.status !== 200) {
              setDesabilitado(true);
              zerarExtras();
              toast.error(
                response.data.message
                  ? response.data.message
                  : tPagamento("extras.calculationError"),
              );
              throw new Error(
                response.data.message
                  ? response.data.message
                  : tPagamento("extras.calculationError"),
              );
              return;
            }
            const data = ResponseCalculoExtras.map(response.data);
            setCalculoExtrasIncrementados(data);
          })
          .catch((error) => {
            console.error(error);
            setCalculoExtrasIncrementados(null);
          });
      }
    }

    function verificarPossuiExtrasAdicionados() {
      for (const extra of extrasDisponiveis) {
        if (extra.camposTela.adicionadoAoCarrinho > 0) {
          setPossuiExtrasAdicionados(true);
          return;
        }
      }

      setPossuiExtrasAdicionados(false);
    }

    function valorFormatado() {
      return formatarReal(calculoExtrasIncrementados?.total);
    }

    function onClickFazerPagamento() {
      if (desabilitado) {
        return;
      }
      const listaItemExtrasAtual = [];
      for (const extra of listaExtras) {
        if (extra.camposTela.status === ITEM_CONTRATADO) {
          listaItemExtrasAtual.push(
            ItensRealizarPagamentoFactory.criarSubItemDescricao(
              extra.nomeExtra +
                `${extra?.quantidadeContratada > 1 ? ` (${extra?.quantidadeContratada})` : ""}`,
              null,
            ),
          );
        }
      }

      const itemDescricaoExtrasAtual = ItensRealizarPagamentoFactory.criarItemDescricao(
        tPagamento("extras.currentPlanExtras"),
        listaItemExtrasAtual,
      );

      const listaItemExtrasContratando = [];
      for (const extra of calculoExtrasIncrementados.listaItens) {
        const itemSelecionado = extrasDisponiveis.find(
          (e) => e.idItemConfiguracao === extra.idItemConfiguracao,
        );

        listaItemExtrasContratando.push(
          ItensRealizarPagamentoFactory.criarSubItemDescricao(
            extra.descricao +
              `${
                itemSelecionado?.camposTela?.adicionadoAoCarrinho > 1
                  ? ` (${itemSelecionado?.camposTela?.adicionadoAoCarrinho})`
                  : ""
              }`,
            extra.valor,
          ),
        );
      }

      const itemDescricaoExtrasContratando = ItensRealizarPagamentoFactory.criarItemDescricao(
        tPagamento("extras.hiredExtras"),
        listaItemExtrasContratando,
      );

      const listaTotal = [];
      listaTotal.push(
        ItensRealizarPagamentoFactory.criarItemTotal(
          tPagamento("extras.totalExtras"),
          calculoExtrasIncrementados.total,
        ),
      );

      const listaDetalhes = [];
      listaDetalhes.push(itemDescricaoExtrasAtual);
      listaDetalhes.push(itemDescricaoExtrasContratando);

      const extrasPagamento = () => {
        const corpo = [];

        for (const extra of extrasDisponiveis) {
          if (extra.camposTela.adicionadoAoCarrinho > 0) {
            corpo.push({
              idItemConfiguracao: extra.idItemConfiguracao,
              quantidadeExtra: extra.camposTela.adicionadoAoCarrinho,
            });
          }
        }

        return post("/contrato/consumidor/waychef/empresa-contrato/item/extra", {
          listaExtras: corpo,
        })
          .then((response) => {
            if (response.status === 200) {
              toast.success(tPagamento("extras.hiredSuccessfully"));
              irParaPlano();
            } else {
              toast.error(
                response.data?.message ? response.data?.message : tPagamento("extras.hireError"),
              );
              throw new Error(response);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      };

      const dadosPagamento = {
        titulo: tPagamento("extras.additionTitle"),
        avisoAntesPagamento: tPagamento("extras.remainingDaysNotice"),
        listaTotal: listaTotal,
        listaDetalhes: listaDetalhes,
        realizarPagamentoFuncao: extrasPagamento,
      };

      irParaPagamento(dadosPagamento);
    }

    const styleDesabilitado = desabilitado
      ? {
          pointerEvent: "none",
          backgroundColor: "transparent",
          color: tema.cores.textActionDisable,
          border: `1px solid ${tema.cores.actionDisable}`,
          cursor: "auto",
        }
      : {};

    return (
      <div>
        {possuiExtrasAdicionados && (
          <ContainerValorTotalPlano>
            <ContainerTextoValorTotalPlano>
              <ContainerTituloValorTotalPlano>
                <TituloValorTotalPlano>{tPagamento("extras.totalValue")}</TituloValorTotalPlano>
                <ValorTotalPlano>{valorFormatado()}</ValorTotalPlano>
              </ContainerTituloValorTotalPlano>
              <SubtituloValorPlano>
                {tPagamento("extras.totalValueDescription", {
                  value: valorFormatado(),
                })}
              </SubtituloValorPlano>
            </ContainerTextoValorTotalPlano>
            <BotaoAzulVazado
              onClick={onClickFazerPagamento}
              style={{ ...styleDesabilitado }}
              texto={tPagamento("extras.pay")}
            />
          </ContainerValorTotalPlano>
        )}
      </div>
    );
  }

  return (
    <div>
      {/*listaExtras*/}
      <StyledAccordion defaultExpanded style={{ marginBottom: 32 }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1d-content"
          id="panel1d-header"
        >
          <TypographyTitulo>{tPagamento("tabs.extras")}</TypographyTitulo>
        </AccordionSummary>

        {loading ? (
          <LinhaClaraExtras
            style={{
              width: "100%",
              height: "fit-content",
              justifyContent: "center",
              padding: 0,
              paddingRight: 0,
            }}
          >
            <Carregando />
          </LinhaClaraExtras>
        ) : (
          listaExtras.map((e, index) => (
            <ItemExtra item={e} index={index} key={e.nomeExtra + "ItemExtra" + index} />
          ))
        )}
      </StyledAccordion>

      <PainelAlteracaoExtras extrasDisponiveis={listaExtras} />
    </div>
  );
}
